import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_explore-journeys-26/artifacts/4jx8ieos_PHOTO-2026-06-24-12-59-57.jpeg";

const nav = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Destinations", href: "#destinations" },
  { label: "Why Celesta", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-purple-900/10 shadow-[0_2px_20px_rgba(74,29,150,0.06)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            data-testid="brand-logo"
            className="flex items-center gap-3 group"
          >
            <img
              src={LOGO}
              alt="Celesta"
              className="h-12 w-12 object-contain"
            />
            <div className="flex flex-col leading-none">
              <span className="font-serif text-xl tracking-[0.3em] text-[#4A1D96] font-semibold">
                CELESTA
              </span>
              <span className="text-[9px] uppercase tracking-[0.24em] text-[#F97316] mt-1 font-semibold">
                Book anything · Travel everywhere
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm uppercase tracking-[0.16em] text-[#1B0F3A] hover:text-[#F97316] transition-colors font-medium"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#contact"
            data-testid="header-cta"
            className="hidden lg:inline-flex items-center px-5 py-2.5 bg-[#F97316] text-white text-sm uppercase tracking-[0.18em] font-semibold hover:bg-[#4A1D96] transition-colors"
          >
            Book Now
          </a>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-[#4A1D96] p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden pb-6 pt-2 border-t border-purple-900/10 bg-white"
          >
            <div className="flex flex-col gap-4 pt-4">
              {nav.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-[0.18em] text-[#1B0F3A] hover:text-[#F97316] transition-colors font-medium"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#F97316] text-white text-sm uppercase tracking-[0.18em] font-semibold hover:bg-[#4A1D96] transition-colors"
              >
                Book Now
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
